<template>
  <myhead @next="next" ref="myHead">
    <router-link to="/me">
      <img :onerror="userError" :src="$store.state.loginInfo.headPic? $store.state.loginInfo.headPic : '@/assets/img/me2.png'"
        class="width30px pointer height30px radius50 absolute r t mt8 mr110" alt="">
    </router-link>
  </myhead>
  <!--  -->
  <div class="width22 auto fixed l r" style="height:44%;top:55px" @click="closeAboutUs"></div>
  <div class="width60 auto fixed l r opacity5 pointer" style="height:18%;bottom:15%" @click="$refs['myHead'].lookmore()"></div>
  <div class="fixed l b center r mb40 zIndex1 line2 size12 C888">
    <a href="https://beian.miit.gov.cn/#/Integrated/index" class="mr10">
      浙ICP备2022002301号-2
    </a>
    <a href="javascript:;">浙公网安备 33011002017160号</a>
  </div>
  <div class="ohide fixed Cfff l r b line40 size14">
    <div class="scroll noscroll" id="scrollBox">
      <div class="flex nowrap">
        <a href="javascript:;" @click.stop="gotoPage(item.id)" v-for="item,index in list" v-show="list.length>1 & !touch" :key="index"
          class="nowrap">{{item.name}}</a>
        <a href="javascript:;" @click.stop="gotoPage(item.id)" v-for="item,index in list" :key="index" class="nowrap">{{item.name}}</a>
        <a href="javascript:;" @click.stop="gotoPage(item.id)" v-for="item,index in list" v-show="list.length>1 & !touch" :key="index"
          class="nowrap">{{item.name}}</a>
        <span class="pad6"></span>
      </div>
    </div>
  </div>
  <van-overlay :show="show" style="z-index:9999999999999999!important">
    <div class="wrapper" @click.stop>
      <div class="block">
        <div v-html="con"></div>
        <p class="closefont" @click="closeAboutUs">×</p>
        <div class="flex block-btn">
          <router-link to="/recruit?active=2">加入使命中人</router-link>
          <router-link to="/forum?active=1">我有问题咨询</router-link>
          <router-link to="/join?active=2">我要加盟国会</router-link>
        </div>
      </div>
    </div>
  </van-overlay>
</template>
<script>
export default ({
  name: 'Home',
  comments: {},
  data () {
    return {
      list: [],
      touch: false,
      show: false,
      con: ""
    }
  },
  methods: {
    initialScroll () {
      if (this.$store.state.timer) {
        clearTimeout(this.$store.state.timer); this.$store.state.timer = null;
      }
      this.touch = false;
      let clientWidth = document.getElementById("scrollBox").clientWidth
      let scrollWidth = document.getElementById("scrollBox").scrollWidth
      let scrollLeft = document.getElementById("scrollBox").scrollLeft
      if (scrollWidth <= clientWidth) {
        return;
      }
      if (scrollWidth > clientWidth && scrollLeft == 0) {
        document.getElementById("scrollBox").scrollLeft = scrollWidth / 3;
      } else if (scrollLeft + clientWidth >= scrollWidth) {
        document.getElementById("scrollBox").scrollLeft = scrollWidth / 3;
      } else {
        document.getElementById("scrollBox").scrollLeft += 1;
      }
      this.$store.state.timer = setTimeout(() => {
        this.initialScroll();
      }, 18)
    },
    filterWeight (word) {
      var len = 0;
      for (let i = 0; i < word.length; i++) {
        var c = word.charCodeAt(i);
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
          len++;
        }
        else {
          len += 2;
        }
      }
      return len * 7 + 26;
    },
    next () {

      history.forward()
    },
    closeAboutUs () {
      this.show = !this.show
    },
    getAboutUs () {
      const data = {
        typeid: 5
      }
      return this.ajax.post("api/getagreement", data).then(res => {
        if (res.data.content !== "") {
          this.con = res.data.content
        }
      })
    },
    gotoPage (id) {
      const data = {
        id: id
      }
      this.ajax.post('index/getactivityinfo', data).then(res => {
        this.$router.push(res.data.url)
      })
    }
  },
  created () {
    this.getAboutUs()
  },
  mounted () {
    this.ajax.post("index/getactivitylist").then(({ data }) => {
      this.list = data;
      setTimeout(() => {
        this.initialScroll();
        document.getElementById('scrollBox').addEventListener("touchstart", () => {
          if (this.$store.state.timer) {
            clearTimeout(this.$store.state.timer); this.$store.state.timer = null;
          }
          this.$store.state.timer = setTimeout(() => {
            this.initialScroll();
          }, 3000)
        })
        document.getElementById('scrollBox').addEventListener("touchmove", () => {
          if (!this.touch) {
            document.getElementById("scrollBox").scrollLeft = document.getElementById("scrollBox").scrollLeft % (document.getElementById("scrollBox").scrollWidth / 3)
          }
          this.touch = true;
          if (this.$store.state.timer) {
            clearTimeout(this.$store.state.timer); this.$store.state.timer = null;
          }
        })
        document.getElementById('scrollBox').addEventListener("touchend", () => {
          if (this.$store.state.timer) {
            clearTimeout(this.$store.state.timer); this.$store.state.timer = null;
          }
          this.$store.state.timer = setTimeout(() => {
            this.initialScroll();
          }, 5000)
        });
      }, 100)
    })
  }
})
</script>

<style scoped lang="scss">
  #scrollBox a+a::before{content:'/';display: inline-block; margin: 0 8px; opacity: .7; }

  .btnBox>*{
    width: 70px; transform: scale(0.75); height: 15px; line-height: 14px;
    background: rgb(151, 151, 151); text-align:center;
    font-size:12px; margin-bottom: 4px; display: inline-block;
    border-top: solid 1px #444;
    border-bottom: solid 1px rgb(163, 163, 163);
    border-right: solid 1px rgb(163, 163, 163);
    border-left: solid 1px #444; position: relative;
    box-shadow: -1px -1px 0 1px #999;
  }
  .bg{
    &>img{height:160px;}
  }
  .leftStar,.rightStar{
    position: relative;
    &:after{
      content:"";display: block;position: absolute; bottom:30%;
      background: white; filter: blur(1px); height: 3px; width: 3px;
      box-shadow: 0 0 2px rgba(255,255,255,.5);
    }
  }
  .leftStar:after{left:-10px;opacity: .8; }
  .rightStar:after{right:-5px; box-shadow: 0 0 2px 1px rgba(255,255,255,.5); }
  @media screen and (min-width:1025px) { //PC样式
    .leftStar,.rightStar{
      &:after{
        filter: blur(1.5px);height: 4px; width: 4px;
      }
    }
    .rightStar:after{right:-7px;}
    .btnBox>*{
      height: 31px; line-height: 30px; width: 110px; font-size: 17px; margin-bottom: 10px;
    }
  }
  .wrapper {
    width: 90%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 100%;
    padding: 35px 20px;
    background-color: #fff;
    position: relative;
    word-break: break-all;
  }
  .block p {
    text-align: center;
    font-size: 16px;
  }
  .block  .block-tle {
    font-size: 22px;
  }
  .block-t {
    margin-bottom: 10px;
  }
  .block-btn {
    width:60%;
    margin: 20px auto 0;
    color: #3c7c94;
    font-size: 16px;
    justify-content: space-between;
  }
  .block .closefont {
    position: absolute;
    font-size: 36px;
    top: 0;
    right: 30px;
    z-index: 999;
  }
</style>
